import React from 'react';
import classnames from 'classnames';

import './Fader.css';

export default function Fader({visible=false, on_transition_end=null, children}) {
	return <div className={classnames("Fader", {'Fader-visible': visible})} onTransitionEnd={on_transition_end}>
		{children}
	</div>
}


// WEBPACK FOOTER //
// ./src/Fader.js